import { jsx as e, jsxs as p, Fragment as q } from "react/jsx-runtime";
import { withManagedProps as x } from "@made-people/managed-props";
import { z as o } from "zod";
import { withZod as M } from "@made-people/react-prop-guard";
import { mixAndMatchActiveProductCardBlueprint as X, mixAndMatchDrawerBlueprint as Y, mixAndMatchNavigationBlueprint as Z, mixAndMatchCardBlueprint as G, mixAndMatchBlueprint as J } from "./index-blueprint.es.js";
import { componentWrapperSchema as W, ComponentWrapper as Q } from "@made-people/blueprint-component-wrapper";
import { headingSchema as ee, Heading as te } from "@made-people/blueprint-heading";
import re, { createContext as ie, useState as b, useContext as ae, useEffect as y, useMemo as se, Children as L, isValidElement as ne, cloneElement as oe } from "react";
import { useProductOptions as ce, useProductPriceInfo as O, useProductBase as _, useProductPurchaseStatus as de, useProductAttribute as le, ProductLink as me, ProductProvider as R, useProductImages as z, productSchema as ue } from "@made-people/grease-product";
import { ResponsiveImage as F, responsiveImageBaseSchema as pe } from "@made-people/blueprint-responsive-image";
import { useTranslate as k } from "@made-people/grease-translations";
import { AnimatePresence as he, motion as B } from "motion/react";
import { buttonAsButtonSchema as ve, ButtonAsButton as K, buttonAsLinkSchema as fe, ButtonAsLink as D } from "@made-people/blueprint-button";
import { toast as E } from "sonner";
import { useCartMethod as ge } from "@made-people/grease-cart";
import { overlayEventEmitter as C } from "@made-people/blueprint-overlay";
import { Drawer as j } from "@made-people/blueprint-drawer";
import { clsx as V } from "clsx";
import { useKeenSlider as we } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { useSearchResultItems as Ae } from "@made-people/grease-search";
import "@made-people/blueprint";
const U = ie(
  void 0
), Se = ({
  children: n,
  amountOfProductLists: i
}) => {
  const [t, r] = b({}), [s, d] = b({}), f = {
    activeProducts: t,
    setActiveProduct: (l, c) => {
      r((a) => ({
        ...a,
        [l]: c
      }));
    },
    removeActiveProduct: (l) => {
      r((c) => {
        const a = { ...c };
        return delete a[l], a;
      });
    },
    clearActiveProducts: () => {
      r({});
    },
    selectedIds: s,
    setSelectedId: (l, c) => {
      d((a) => ({
        ...a,
        [l]: c
      }));
    },
    amountOfProductLists: i,
    clearSelectedSizes: () => {
      d({});
    }
  };
  return /* @__PURE__ */ e(U.Provider, { value: f, children: n });
}, N = () => {
  const n = ae(U);
  if (n === void 0)
    throw new Error("useMixAndMatch must be used within a MixAndMatchProvider");
  return n;
}, be = o.object({
  variants: o.custom().optional(),
  swiperIndex: o.number()
}), xe = x(
  "ActiveProductCard",
  M(
    be,
    ({ variants: n, swiperIndex: i }) => {
      const t = X.styles(n), r = k(), { optionGroups: s, selectedOptions: d, selectOption: g } = ce(), { setSelectedId: h } = N(), u = O(), {
        content: { name: v, media: m },
        slug: f
      } = _(), l = de(), c = _(), a = le("productFit", o.array(o.string())), w = u.price.number < u.priceWithoutDiscount.number, [P, I] = b(null);
      return y(() => {
        l.status === "available" && l.availableItemId !== P && (console.log(
          `[ActiveProductCard] Updating ID for swiper ${i} to:`,
          l.availableItemId
        ), h(i, l.availableItemId), I(l.availableItemId));
      }, [l]), /* @__PURE__ */ e(he, { mode: "wait", children: /* @__PURE__ */ p(B.div, { className: t.wrapper, children: [
        /* @__PURE__ */ p(
          me,
          {
            productBase: c,
            className: t.contentWrapper,
            children: [
              /* @__PURE__ */ e(F, { image: m[0], className: t.image }),
              /* @__PURE__ */ p("div", { className: t.content, children: [
                /* @__PURE__ */ e(
                  B.span,
                  {
                    initial: { opacity: 0 },
                    animate: { opacity: 1 },
                    exit: { opacity: 0 },
                    className: t.name,
                    transition: { duration: 0.5, ease: "easeInOut" },
                    children: v
                  },
                  v
                ),
                (a == null ? void 0 : a.value) && /* @__PURE__ */ e("span", { className: t.productFit, children: a.value[0] }),
                /* @__PURE__ */ p("div", { className: t.priceWrapper, children: [
                  /* @__PURE__ */ e(
                    "span",
                    {
                      "data-is-discounted": w ? "true" : "false",
                      className: t.price,
                      children: u.price.formatted
                    }
                  ),
                  w && /* @__PURE__ */ e("span", { className: t.priceBeforeDiscount, children: u.priceWithoutDiscount.formatted })
                ] })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ p("div", { className: t.sizeSelectorWrapper, children: [
          /* @__PURE__ */ e("span", { className: t.sizeSelectorHeading, children: r("PDP_Size_Picker_Select_Size") }),
          s.map((S) => /* @__PURE__ */ e(
            "div",
            {
              className: t.sizeSelector,
              children: S.options.map((A) => {
                var T;
                return /* @__PURE__ */ e(
                  "button",
                  {
                    "data-is-selected": ((T = d[S.dimensionKey]) == null ? void 0 : T.dimensionValue) === A.dimensionValue,
                    "data-is-out-of-stock": A.inventory.inStock ? "false" : "true",
                    className: t.size,
                    disabled: !A.inventory.inStock,
                    onClick: () => {
                      g(S.dimensionKey, A);
                    },
                    children: A.label
                  },
                  A.dimensionValue
                );
              })
            },
            S.dimensionKey
          ))
        ] })
      ] }) });
    }
  )
), Me = o.object({}), H = x(
  "MixAndMatchActiveProducts",
  M(Me, () => {
    const { activeProducts: n } = N();
    return /* @__PURE__ */ e(q, { children: Object.entries(n).map(([i, t], r) => /* @__PURE__ */ e(
      R,
      {
        product: t,
        context: {
          type: "plp",
          listId: "mix-and-match-active-products",
          listName: "Mix & Match Active Products",
          position: r
        },
        children: /* @__PURE__ */ e(xe, { swiperIndex: r })
      },
      i
    )) });
  })
), Pe = o.object({
  variants: ve.shape.variants.optional()
}), $ = x(
  "MixAndMatchAddToCart",
  M(
    {
      schema: Pe,
      defaultProps: {
        variants: {
          size: { initial: "md", lg: "md" },
          color: "black",
          width: "full"
        }
      }
    },
    ({ variants: n }) => {
      const i = k(), { execute: t } = ge("addToCart"), [r, s] = b("default"), {
        selectedIds: d,
        amountOfProductLists: g,
        activeProducts: h,
        clearSelectedSizes: u
      } = N(), v = Object.keys(d).length === g, m = async () => {
        if (!v) {
          E.warning(i("Add_To_Cart_Error_Not_Available_Toast"));
          return;
        }
        try {
          s("loading"), await Promise.all(
            Object.entries(d).map(async ([f, l]) => {
              const c = h[parseInt(f)];
              if (c)
                return t({
                  itemId: l,
                  product: c.base
                });
            })
          );
        } catch (f) {
          s("default"), E.error(i("Add_To_Cart_Error_Toast")), console.error("Error adding to cart:", f);
          return;
        }
        s("complete"), setTimeout(() => {
          s("default"), C.emit("close", {
            overlayId: "mix-and-match-drawer"
          }), C.emit("open", { overlayId: "mini-cart" }), u();
        }, 1e3);
      };
      return /* @__PURE__ */ e(
        K,
        {
          label: i(v ? "Mix_And_Match_Add_To_Cart" : "Mix_And_Match_Select_Size"),
          progress: r,
          onClick: m,
          variants: n
        }
      );
    }
  )
), Ie = {
  direction: "bottom",
  variants: {
    rounded: "subtle"
  }
}, Ne = {
  style: "solid",
  color: "black",
  width: "full"
}, ye = o.object({
  //   variants: z
  //     .custom<VariantProps<typeof quickshopDrawerBlueprint>>()
  //     .optional()
  //     .describe("Variants for the drawer"),
  drawerSettings: o.custom().optional().describe("Settings for the drawer"),
  buttonVariants: o.custom().optional().describe("Variants for the button"),
  trigger: o.union([
    o.string(),
    o.custom(),
    o.custom()
  ]).optional().describe(
    "The trigger for the drawer, can be a string, a component or an element"
  )
}), _e = x(
  "MixAndMatchDrawer",
  M(
    {
      schema: ye,
      defaultProps: {
        drawerSettings: Ie,
        buttonVariants: Ne
      }
    },
    ({ drawerSettings: n, buttonVariants: i }) => {
      const t = Y.styles(), r = k();
      return /* @__PURE__ */ p(j, { ...n, customOverlayId: "mix-and-match-drawer", children: [
        /* @__PURE__ */ e(
          K,
          {
            onClick: () => C.emit("open", {
              overlayId: "mix-and-match-drawer"
            }),
            variants: i,
            className: t.trigger,
            label: r("Mix_And_Match_Select_Size")
          }
        ),
        /* @__PURE__ */ e(j.Content, { children: /* @__PURE__ */ p("div", { className: t.base, children: [
          /* @__PURE__ */ e(H, {}),
          /* @__PURE__ */ e("div", { className: t.addToCartWrapper, children: /* @__PURE__ */ e($, {}) })
        ] }) })
      ] });
    }
  )
), Ce = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "14",
    height: "15",
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e(
      "path",
      {
        d: "M9.0999 11.5001L4.8999 7.3001L9.0999 3.1001",
        stroke: "#18181B",
        strokeWidth: "1.4",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), ke = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "14",
    height: "15",
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e(
      "path",
      {
        d: "M4.8999 11.5001L9.0999 7.3001L4.8999 3.1001",
        stroke: "#18181B",
        strokeWidth: "1.4",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Te = ({
  instanceRef: n,
  slideWidth: i
}) => {
  const t = Z.styles();
  return /* @__PURE__ */ p("div", { className: t.wrapper, style: { width: `${i + 24}px` }, children: [
    /* @__PURE__ */ e(
      "button",
      {
        onClick: (r) => {
          var s;
          r.stopPropagation(), (s = n.current) == null || s.prev();
        },
        className: t.button,
        children: /* @__PURE__ */ e(Ce, {})
      }
    ),
    /* @__PURE__ */ e(
      "button",
      {
        onClick: (r) => {
          var s;
          r.stopPropagation(), (s = n.current) == null || s.next();
        },
        className: t.button,
        children: /* @__PURE__ */ e(ke, {})
      }
    )
  ] });
}, We = "is_mix_and_match_image", Le = o.object({
  blueprint: o.custom().optional(),
  variants: o.custom().optional(),
  imageSettings: pe.optional(),
  isActive: o.boolean().optional()
}), ze = x(
  "Card",
  M(
    {
      schema: Le,
      defaultProps: {}
    },
    ({ variants: n, isActive: i }) => {
      const t = G.styles(n), {
        content: { name: r }
      } = _(), s = O(), d = z(), h = z({
        attributeFilter: {
          key: We,
          value: [!0]
        }
      })[0] ?? d[0], u = s.price.number < s.priceWithoutDiscount.number;
      return /* @__PURE__ */ p(
        "div",
        {
          className: t.imageWrapper,
          "data-is-active": i ? "true" : "false",
          children: [
            h && /* @__PURE__ */ e(
              F,
              {
                image: { src: h.src, alt: h.alt },
                className: t.image,
                displaySize: {
                  mobile: "50vw",
                  tablet: "50vw",
                  desktop: "20vw"
                }
              }
            ),
            /* @__PURE__ */ e("span", { className: t.name, children: r }),
            /* @__PURE__ */ p("div", { className: t.priceWrapper, children: [
              /* @__PURE__ */ e(
                "span",
                {
                  "data-is-discounted": u ? "true" : "false",
                  className: t.price,
                  children: s.price.formatted
                }
              ),
              u && /* @__PURE__ */ e("span", { className: t.priceBeforeDiscount, children: s.priceWithoutDiscount.formatted })
            ] })
          ]
        }
      );
    }
  )
), nt = o.object({
  products: o.array(ue)
}), Be = ({ swiperIndex: n, products: i }) => {
  var l;
  const { setActiveProduct: t } = N(), [r, s] = re.useState(0), [d, g] = b(!1), [h, u] = b(0), [v, m] = we({
    initial: 0,
    slideChanged(c) {
      s(c.track.details.rel);
    },
    created(c) {
      g(!0), f(c);
    },
    breakpoints: {
      "(min-width: 0px)": {
        slides: {
          origin: "center",
          perView: 2,
          spacing: 3
        }
      },
      "(min-width: 768px)": {
        slides: {
          origin: "auto",
          perView: 2,
          spacing: 15
        }
      },
      "(min-width: 1024px)": {
        slides: {
          origin: "auto",
          perView: 3,
          spacing: 15
        }
      },
      "(min-width: 1660px)": {
        slides: {
          origin: "auto",
          perView: 4,
          spacing: 15
        }
      }
    },
    loop: !0
  });
  y(() => {
    i && i.length > 0 && i[r] && t(n, i[r]);
  }, [r, i, n]);
  const f = (c) => {
    var P, I;
    const a = c.track.details, w = c.container;
    if (a && a.slides.length > 0 && w) {
      const S = ((P = a == null ? void 0 : a.slides) == null ? void 0 : P[0]) && ((I = a == null ? void 0 : a.slides) == null ? void 0 : I[0].size), A = w.offsetWidth;
      u((S ?? 0) * A);
    }
  };
  return y(() => {
    if (!m.current)
      return;
    const c = () => {
      requestAnimationFrame(() => {
        m.current && (f(m.current), m.current.update());
      });
    };
    return window.addEventListener("resize", c), c(), () => {
      window.removeEventListener("resize", c);
    };
  }, []), /* @__PURE__ */ p("div", { className: "relative w-full h-full", children: [
    /* @__PURE__ */ e(
      "div",
      {
        ref: v,
        className: "keen-slider",
        style: { display: "flex", flexDirection: "row", overflow: "hidden" },
        children: i.map((c, a) => /* @__PURE__ */ e(
          "div",
          {
            "data-is-active": r === a ? "true" : "false",
            className: "keen-slider__slide h-full w-full empty:hidden",
            onClick: () => {
              var w;
              a !== r && ((w = m.current) == null || w.moveToIdx(a));
            },
            style: { minWidth: 0, minHeight: 0, position: "relative" },
            children: /* @__PURE__ */ e(
              R,
              {
                product: c,
                context: {
                  type: "plp",
                  listId: "mix-and-match-product-list",
                  listName: "Mix & Match Product List",
                  position: a
                },
                children: /* @__PURE__ */ e(ze, { isActive: r === a })
              }
            )
          },
          a
        ))
      }
    ),
    d && m.current && /* @__PURE__ */ e(
      Te,
      {
        instanceRef: m,
        slideWidth: h,
        totalSlides: ((l = m.current) == null ? void 0 : l.track.details.slides.length) || 1
      }
    )
  ] });
}, De = (n) => {
  const i = Ae();
  if (!i)
    return null;
  const t = (i ?? []).filter((r) => r.type === "product").map((r) => r.product);
  return /* @__PURE__ */ e(Be, { ...n.swiper, products: t });
}, Ee = o.object({
  layout: W.shape.layout.optional(),
  heading: ee.optional(),
  children: o.array(o.custom()).optional(),
  variants: o.custom().optional(),
  link: fe.optional()
}).merge(W), ot = x(
  "MixAndMatch",
  M(
    {
      schema: Ee,
      defaultProps: {
        variants: {
          layout: {
            initial: "column",
            md: "horizontal"
          }
        },
        link: {
          variants: {
            style: "outline",
            width: "full",
            size: { initial: "md", lg: "md" }
          }
        },
        heading: {
          variants: {
            headingSize: { initial: "lg", lg: "xl" },
            eyebrowSize: "2xs"
          }
        }
      }
    },
    ({ layout: n, variants: i, heading: t, link: r, ...s }) => {
      var h, u;
      const d = J.styles(i), g = se(
        () => L.map(s.children, (v, m) => ne(v) ? oe(v, {
          key: m,
          // Override the children of the product lists with the SwiperWrapper
          children: /* @__PURE__ */ e(De, { swiper: { swiperIndex: m } })
        }) : null),
        [s.children]
      );
      return /* @__PURE__ */ e(
        Se,
        {
          amountOfProductLists: L.count(s.children),
          children: /* @__PURE__ */ p(Q, { layout: n, className: d.base, ...s, children: [
            t && /* @__PURE__ */ e(te, { ...t, className: d.heading }),
            /* @__PURE__ */ p("div", { className: d.contentWrapper, children: [
              /* @__PURE__ */ e("div", { className: d.activeProductsWrapper, children: /* @__PURE__ */ e(H, {}) }),
              /* @__PURE__ */ p("div", { className: V(d.buttonsWrapper), children: [
                /* @__PURE__ */ e($, {}),
                ((h = r == null ? void 0 : r.link) == null ? void 0 : h.href) && /* @__PURE__ */ e(D, { ...r })
              ] })
            ] }),
            /* @__PURE__ */ e("div", { className: d.listsWrapper, children: g }),
            /* @__PURE__ */ p("div", { className: V(d.bottomSection, "block md:hidden"), children: [
              /* @__PURE__ */ e(_e, {}),
              ((u = r == null ? void 0 : r.link) == null ? void 0 : u.href) && /* @__PURE__ */ e(D, { ...r })
            ] })
          ] })
        }
      );
    }
  )
);
export {
  xe as ActiveProductCard,
  H as ActiveProducts,
  $ as AddToCart,
  ze as Card,
  Ce as ChevronLeft,
  ke as ChevronRight,
  We as MIX_AND_MATCH_IMAGE_ATTRIBUTE_KEY,
  ot as MixAndMatch,
  _e as MixAndMatchDrawer,
  Ee as MixAndMatchPropsSchema,
  Se as MixAndMatchProvider,
  Te as Navigation,
  Be as Swiper,
  De as SwiperWrapper,
  be as activeProductCardSchema,
  Me as activeProductsSchema,
  Le as cardSchema,
  Pe as mixAndMatchAddToCartSchema,
  ye as mixAndMatchDrawerSchema,
  nt as swipeableProductListSchema,
  N as useMixAndMatch
};
//# sourceMappingURL=index.es.js.map
